import { render } from "./Reorder.vue?vue&type=template&id=43c1014a"
import script from "./Reorder.vue?vue&type=script&lang=js"
export * from "./Reorder.vue?vue&type=script&lang=js"

import "./Reorder.vue?vue&type=style&index=0&id=43c1014a&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__